export const USER_PERMISSION_ACTIONS = ["add", "edit", "view", "delete"];

export const DEFAULT_USER_TYPE_PERMISSIONS = {
  customer: {
    id: "customer",
    label: "Customer",
    system: true,
    add: true,
    edit: true,
    view: true,
    delete: true
  },
  driver: {
    id: "driver",
    label: "Driver",
    system: true,
    add: true,
    edit: true,
    view: true,
    delete: true
  },
  fleetadmin: {
    id: "fleetadmin",
    label: "Fleet Admin / Logistics Company",
    system: true,
    add: true,
    edit: true,
    view: true,
    delete: true
  },
  admin: {
    id: "admin",
    label: "Admin / Super Admin",
    system: true,
    add: true,
    edit: true,
    view: true,
    delete: true
  }
};

const cleanPermissionValue = (value, fallback = true) => {
  return value === undefined || value === null ? fallback : !!value;
};

export const normalizeUserTypePermissions = (settings = {}) => {
  const saved = settings.userTypePermissions || {};
  const merged = { ...DEFAULT_USER_TYPE_PERMISSIONS };

  Object.keys(saved).forEach((key) => {
    const item = saved[key] || {};
    merged[key] = {
      id: item.id || key,
      label: item.label || DEFAULT_USER_TYPE_PERMISSIONS[key]?.label || key,
      system: item.system !== undefined ? !!item.system : !!DEFAULT_USER_TYPE_PERMISSIONS[key]?.system,
      add: cleanPermissionValue(item.add, DEFAULT_USER_TYPE_PERMISSIONS[key]?.add),
      edit: cleanPermissionValue(item.edit, DEFAULT_USER_TYPE_PERMISSIONS[key]?.edit),
      view: cleanPermissionValue(item.view, DEFAULT_USER_TYPE_PERMISSIONS[key]?.view),
      delete: cleanPermissionValue(item.delete, DEFAULT_USER_TYPE_PERMISSIONS[key]?.delete)
    };
  });

  return Object.keys(merged).map((key) => ({
    ...merged[key],
    id: merged[key].id || key
  }));
};

export const buildUserTypePermissionsMap = (rows = []) => {
  return rows.reduce((map, row) => {
    if (!row || !row.id) return map;
    map[row.id] = {
      id: row.id,
      label: row.label || row.id,
      system: !!row.system,
      add: !!row.add,
      edit: !!row.edit,
      view: !!row.view,
      delete: !!row.delete
    };
    return map;
  }, {});
};

export const hasUserPermission = (settings = {}, userType, action) => {
  const permissions = normalizeUserTypePermissions(settings).find((row) => row.id === userType);
  if (!permissions || USER_PERMISSION_ACTIONS.indexOf(action) === -1) return true;
  return permissions[action] !== false;
};

export const makeUserTypeId = (value) => {
  return (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
};
